import env from '../utils/env';
import nativeApi from '../utils/nativeApi';
import {
  showPicker,
  hidePicker,
  showLoading,
  hideLoading,
  showPopup,
  hidePopup,
  showNotification,
  hideNotification,
  showOptions,
  hideOptions,
  showFullLoading,
  hideFullLoading
} from './base';

function updateTitle(title) {
  document.title = title;
  if (env.isNative) {
    nativeApi.invoke('updateTitle', {
      text: title
    });
  }
}

function withLoading(fn, { title } = { title: '' }) {
  return (...args) => {
    showLoading({ title });
    return fn(...args).then(r => {
      hideLoading();
      return r;
    }, e => {
      hideLoading();
      throw e;
    });
  };
}

function withFullLoading(fn, { title } = { title: '' }){
  return (...args) => {
    showFullLoading({ title });
    return fn(...args).then(r => {
      hideFullLoading();
      return r;
    }, e => {
      hideFullLoading();
      throw e;
    });
  };
}

export default {
  showPicker,
  hidePicker,
  showOptions,
  hideOptions,
  showLoading,
  hideLoading,
  showPopup,
  hidePopup,
  showNotification,
  hideNotification,
  updateTitle,
  withLoading,
  withFullLoading
};



// WEBPACK FOOTER //
// ./src/ui/index.js